import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skeletonNaveCard" }
const _hoisted_2 = { class: "d-flex gap-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, { cols: "7" }, {
          default: _withCtx(() => [
            _createVNode(_component_Skeleton, {
              class: "mb-4",
              width: "30rem",
              height: "2rem"
            }),
            _createVNode(_component_Skeleton, {
              class: "mb-5",
              width: "20rem",
              height: "5rem"
            }),
            _createVNode(_component_Skeleton, {
              class: "mb-3",
              width: "35rem",
              height: "1rem"
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Skeleton, {
                width: "8rem",
                height: "3rem"
              }),
              _createVNode(_component_Skeleton, {
                width: "8rem",
                height: "3rem"
              }),
              _createVNode(_component_Skeleton, {
                width: "8rem",
                height: "3rem"
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, {
          cols: "2",
          "offset-md": "3",
          class: "my-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Skeleton, {
              width: "100%",
              height: "8rem"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}